<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-tabs>
      <a-tab-pane tab="角色信息" key="ROLE_INFO">
        <a-form-model-item label="角色" prop="name">
          <a-input v-model="form.data.name"/>
        </a-form-model-item>
        <a-form-model-item label="描述" prop="description">
          <a-input v-model="form.data.description"/>
        </a-form-model-item>
        <a-form-model-item label="是否有效" prop="isActive">
          <a-radio-group v-model="form.data.isActive">
            <a-radio value="YES">有效</a-radio>
            <a-radio value="NO">无效</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-tab-pane>
      <a-tab-pane tab="角色菜单" key="ROLE_MENU">
        <a-tree
          v-model="form.data.menuIds"
          :auto-expand-parent="true"
          checkable
          :tree-data="menu.data"
          node-key="id">
        </a-tree>
      </a-tab-pane>
    </a-tabs>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!roleId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="roleId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryRole,
  _addRole,
  _updateRole,
} from '@/api/sysRoleApi';
import {
  _treeGenerator,
  _queryMenus,
} from '@/api/sysMenuApi';

async function getRole() {
  const result = await _queryRole(this.roleId);
  if (result) {
    this.form.data.name = result.role.name;
    this.form.data.description = result.role.description;
    this.form.data.isActive = result.role.isActive;
    this.form.data.menuIds = result.roleMenus.map(x => x.menuId);
  }
}

async function onAdd() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addRole({
        name: this.form.data.name,
        description: this.form.data.description,
        isActive: this.form.data.isActive,
        menuIds: this.form.data.menuIds,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

async function onUpdate() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateRole(this.roleId, {
        name: this.form.data.name,
        description: this.form.data.description,
        isActive: this.form.data.isActive,
        menuIds: this.form.data.menuIds,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          if (this.onSubmitHandler) {
            this.onSubmitHandler();
          }
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'RoleEdit',
  props: {
    roleId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    roleId(val) {
      if (val) {
        this.getRole();
      }
      this.form.data = {
        name: '',
        description: '',
        isActive: 'YES',
        menuIds: [],
      };
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getRole,
  },
  data() {
    return {
      tab: 'ROLE_INFO',
      menu: {
        data: [],
      },
      form: {
        data: {
          name: '',
          description: '',
          isActive: 'YES',
          menuIds: [],
        },
        rules: {
          name: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          }],
          description: [{
            required: false,
            message: 'please input description',
            trigger: 'blur',
          }],
          isActive: [{
            required: false,
            message: 'please choose isActive',
            trigger: 'blur',
          }],
        },
        disabled: false,
        title: '',
      },
    };
  },
  async created() {
    this.tab = 'roleInfo';
    const menuResult = await _queryMenus();
    this.menu.data = menuResult
      .filter(x => !x.parentId)
      .map(x => _treeGenerator(x, menuResult));
    if (this.roleId) {
      this.getRole();
    }
  },
};
</script>
